export const DEFAULT_CRM_TOKEN = 'afe39zbzzld';
export const brandLogo = `${window.assetsLocation}/images/erlanger-newest-logo.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/showcase.png`;
export const bannerUrl = `${window.assetsLocation}/images/erlanger-new-banner.png`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const submitRequestIconUrl = `${window.assetsLocation}/images/request.svg`;
export const loginRequestsIconUrl = `${window.assetsLocation}/images/inbox.svg`;
export const viewAllRequestsIconUrl = `${window.assetsLocation}/images/map.svg`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = ['1'];
export const faqArticleIds = ['1'];
// Get CRM token from environment variable or use default
export const getCrmToken = () => {
    return process.env.CRM_TOKEN || DEFAULT_CRM_TOKEN;
};
// Default logout redirect URL
const DEFAULT_LOGOUT_REDIRECT_URL = 'https://garysanitarydistrictin.comcate.com/en';
// Get logout redirect URL from environment variable or use default
export const getLogoutRedirectUrl = () => {
    const redirectUrl = process.env.LOGOUT_REDIRECT_URL || DEFAULT_LOGOUT_REDIRECT_URL;
    return encodeURIComponent(redirectUrl);
};
// Generate submit request URL with dynamic CRM token
export const getSubmitRequestUrl = () => {
    const token = getCrmToken();
    const logoutRedirect = getLogoutRedirectUrl();
    return `https://agency.comcate.com/private-submission/create?crm_token=${token}&logout_redirect_url=${logoutRedirect}`;
};
// Generate login to account URL with dynamic CRM token
export const getLoginToAccountUrl = () => {
    const token = getCrmToken();
    const logoutRedirect = getLogoutRedirectUrl();
    return `https://agency.comcate.com/private-submission/listing?crm_token=${token}&auth_enabled=true&logout_redirect_url=${logoutRedirect}`;
};
